(() => {
  const allowedEvents = new Set([
    'cafe_hub_view',
    'menu_view',
    'event_view',
    'cafe_route_click',
    'directions_click',
    'event_rsvp_click',
  ]);
  const seenEvents = new Set();

  if (window.Shopify?.designMode || !document.querySelector('[data-cafe-analytics-root]')) return;

  const compact = (value) => (typeof value === 'string' ? value.slice(0, 80) : undefined);

  const eventPayload = (element) => {
    const root = element.closest('[data-cafe-analytics-root]');
    const values = {
      schema_version: 1,
      business_funnel: 'cafe',
      page_role: compact(root?.dataset.pageRole),
      page_handle: compact(root?.dataset.pageHandle),
      location_count: root?.dataset.locationCount ? Number(root.dataset.locationCount) : undefined,
      menu_scope: compact(root?.dataset.menuScope),
      location_id: compact(element.dataset.locationId || root?.dataset.locationId),
      cta_id: compact(element.dataset.ctaId),
      cta_position: compact(element.dataset.ctaPosition),
      destination_funnel: compact(element.dataset.destinationFunnel),
      destination_provider: compact(element.dataset.destinationProvider),
      event_handle: compact(element.dataset.eventHandle || root?.dataset.eventHandle),
      ticket_availability: compact(element.dataset.ticketAvailability || root?.dataset.ticketAvailability),
      registration_type: compact(element.dataset.registrationType),
    };

    return Object.fromEntries(Object.entries(values).filter(([, value]) => value !== undefined));
  };

  const publish = (name, element) => {
    if (!allowedEvents.has(name) || typeof window.Shopify?.analytics?.publish !== 'function') return false;

    try {
      const result = window.Shopify.analytics.publish(`isshiki:${name}`, eventPayload(element));
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch (_error) {
      return false;
    }
  };

  const publishViews = () => {
    document.querySelectorAll('[data-cafe-view-event]').forEach((element) => {
      const name = element.dataset.cafeViewEvent;
      const key = `view:${name}:${element.dataset.pageHandle || ''}:${element.dataset.eventHandle || ''}`;
      if (seenEvents.has(key)) return;
      if (publish(name, element)) seenEvents.add(key);
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const element = event.target.closest('[data-cafe-event]');
    if (!element || event.button !== 0) return;
    publish(element.dataset.cafeEvent, element);
  });

  publishViews();
  window.addEventListener('load', publishViews, { once: true });
})();
